import * as Util from '../core/utilities/am-operators.util';

export class AmSelectListController {
  constructor() {
    this.selected = {};
    this.util = Util;
    this.list = [];
  }

  $onInit() {
    this.onSelection = this.onSelection || undefined;
    if (!this.selected) {
      this.selected = {};
    }
  }

  $onChanges() {}

  $onDestroy() {}

  get isAllSelected() {
    const selectedIds = Object.keys(this.selected);
    return this.isAllListSelected(selectedIds);
  }

  toggelSelectAllPage(event) {
    if (event) {
      event.stopPropagation();
    }
    const isSelectAll = !this.isAllSelected;
    this.list.forEach((item) => {
      isSelectAll ? this.addSelectedItem(item) : this.removeSelectedItem(item);
    });

    if (this.onSelection) {
      this.onSelection({ selected: this.selected });
    }
  }

  toggelSelection(item, event) {
    if (event) {
      event.stopPropagation();
    }
    if (item.id in this.selected) {
      this.removeSelectedItem(item);
    } else {
      this.addSelectedItem(item);
    }

    if (this.onSelection) {
      this.onSelection({ selected: this.selected });
    }
  }

  removeSelectedItem(item) {
    delete this.selected[item.id];
    //  this.updateSelectedResult();
  }

  addSelectedItem(item) {
    this.selected[item.id] = item;
    // this.updateSelectedResult();
  }

  isAllListSelected(selectedIds = []) {
    return this.list.length && this.list.every((a) => selectedIds.includes(`${a.id}`));
  }
}
